import { createContext, useContext, type ReactNode } from "react";
import type {
  createAuthStore,
  createCategoryStore,
  createLogStore,
  createMethodStore,
  createStatsStore,
  createWorkspaceStore,
} from "@repo/share-log-stores";

/**
 * 공유 컴포넌트가 쓰는 store 훅 묶음.
 * 소비 앱이 `@repo/share-log-stores` factory로 만든 인스턴스를 그대로 넣는다.
 */
export interface Stores {
  auth: ReturnType<typeof createAuthStore>;
  workspace: ReturnType<typeof createWorkspaceStore>;
  log: ReturnType<typeof createLogStore>;
  category: ReturnType<typeof createCategoryStore>;
  method: ReturnType<typeof createMethodStore>;
  stats: ReturnType<typeof createStatsStore>;
}

const StoresContext = createContext<Stores | null>(null);

interface StoresProviderProps {
  stores: Stores;
  children: ReactNode;
}

export function StoresProvider({ stores, children }: StoresProviderProps) {
  return (
    <StoresContext.Provider value={stores}>{children}</StoresContext.Provider>
  );
}

export function useStores(): Stores {
  const stores = useContext(StoresContext);
  if (!stores) {
    throw new Error("useStores는 StoresProvider 안에서만 사용할 수 있습니다.");
  }
  return stores;
}
